// extracted by mini-css-extract-plugin
export default {"footerWrapper":"Footer_footerWrapper__bi3wo"};